export default "__VITE_ASSET__Ds2ad6ZW__"